'use client';

import React from 'react';

import { useTipTap } from './Editor.hooks';

const { EditorContent } = require('@tiptap/react');

const decodeHtmlEntities = (obj: any): any => {
  if (typeof obj === 'string') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = obj;
    return textarea.value;
  }

  if (Array.isArray(obj)) {
    return obj.map(decodeHtmlEntities);
  }

  if (obj && typeof obj === 'object') {
    const decoded: any = {};
    for (const key in obj) {
      decoded[key] = decodeHtmlEntities(obj[key]);
    }
    return decoded;
  }

  return obj;
};

export const TipTapToContent = ({ content, ...options }: { content: any; editorProps?: any }) => {
  const decodedContent = React.useMemo(() => decodeHtmlEntities(content), [content]);
  const editor = useTipTap({ content: decodedContent, editable: false, ...options });

  return <EditorContent {...{ editor }} />;
};
